/* ----------------------------- Search Box Typing Effect ----------------------------- */
document.addEventListener("DOMContentLoaded", function() {
  // Get the search input element
  const searchInput = document.querySelector('.js-search-input');
  
  // Get the hidden input that contains the placeholder texts
  const hiddenInput = document.getElementById("custom-searchbox-placeholder-texts");
  
  // Retrieve the value from the hidden input and split it into an array using commas, trimming any extra spaces
  const texts = hiddenInput.value.split(",").map(text => text.trim());

  let textIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  
  // Get the typing speeds and delays from data attributes or use default values
  const typingSpeed = parseInt(searchInput.dataset.typingSpeed) || 100;
  const deletingSpeed = parseInt(searchInput.dataset.deletingSpeed) || 60;
  const delayAfterWordTyped = parseInt(searchInput.dataset.delayAfterWordTyped) || 2400;
  const delayBeforeFirstDelete = parseInt(searchInput.dataset.delayBeforeFirstDelete) || 2000;
  const delayAfterDeleting = parseInt(searchInput.dataset.delayAfterDeleting) || 500;

  function typeEffect() {
    const currentText = texts[textIndex];
    
    if (!isDeleting) {
      // Write one more character
      charIndex++;
      searchInput.setAttribute("placeholder", currentText.substring(0, charIndex));
      
      if (charIndex === currentText.length) {
        // Word complete: wait before starting to delete
        isDeleting = true;
        setTimeout(typeEffect, delayBeforeFirstDelete);
        return;
      }
    } else {
      // Delete one character
      charIndex--;
      searchInput.setAttribute("placeholder", currentText.substring(0, charIndex));
      
      if (charIndex === 0) {
        // Finished deleting: move to the next text
        isDeleting = false;
        textIndex = (textIndex + 1) % texts.length;
        setTimeout(typeEffect, delayAfterDeleting);
        return;
      }
    }
    
    // Set the next call based on whether typing or deleting
    const timeout = isDeleting ? deletingSpeed : typingSpeed;
    setTimeout(typeEffect, timeout);
  }

  // Start the typing effect
  typeEffect();
});

/* ----------------------------- Tippy Tooltip ----------------------------- */
document.addEventListener("DOMContentLoaded", function() {
    tippy('.custom-tooltip', {
    content(reference) {
      return reference.getAttribute('title');
    },
    onMount(instance) {
      instance.reference.removeAttribute('title');
    },
    placement: 'top',
  });
});